module.exports = __webpack_public_path__ + "img/fk.8d1ec12a.svg";